import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import AdminLayout from './components/layout/AdminLayout';
import { useAuth } from './hooks/useAuth';
import { useTheme } from './hooks/useTheme';
import LoginPage from './features/auth/LoginPage';
import DashboardPage from './features/dashboard/DashboardPage';
import TemplatesPage from './features/templates/TemplatesPage';
import ContractsPage from './features/contracts/ContractsPage';
import SettingsPage from './features/settings/SettingsPage';
import ContactsPage from './features/contacts/ContactsPage';
import PublicSigningPage from './features/publicSigning/PublicSigningPage';

function App() {
  const { token, login, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/contracts/sign/:token" element={<PublicSigningPage />} />
        {!token ? (
          <>
            <Route path="/login" element={<LoginPage onLogin={login} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <Route element={<AdminLayout theme={theme} onToggleTheme={toggleTheme} onLogout={logout} />}>
            <Route index element={<DashboardPage token={token} />} />
            <Route path="/contracts" element={<ContractsPage token={token} />} />
            <Route path="/templates" element={<TemplatesPage token={token} />} />
            <Route path="/contacts" element={<ContactsPage token={token} />} />
            <Route path="/settings" element={<SettingsPage token={token} />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
          </Route>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
